module.exports = __webpack_public_path__ + "media/images/agent-summary-7447085b420524fad01a52c41c16486c.svg";